import React, {
  useCallback,
  useEffect,
  useState,
  useContext,
  Fragment,
} from "react";
import { Controller, useForm } from "react-hook-form";
import { AuthContext } from "@app/providers";
import Select from "react-select/";
import {
  stateList,
  objectComparision,
  gradesList,
  getArrayData,
  preferedPronounList,
  formatPhoneNumber,
  capitalize,
  useLocation,
} from "@app/utils";
import {
  FormFlexWrapper,
  DropdownWrapper,
  Error,
  FlexWrapper,
  CommonLabel,
  StateLabel,
  FormHeader,
  FormTitle,
} from "@app/components/commonStyles";
import { SelectCustomStyles } from "@app/components/commonStyles";
import { DataService, updateUser, getAddress } from "@app/services";
import {
  Button,
  Input,
  ProfileUploader,
  Layout,
  Toast,
  ProfileUpdtaeDialog,
  Radio,
  Icon,
} from "@app/components";
import { ButtonContainer, ImageContainer } from "./profile-component";
import PhoneInput from "react-phone-input-2";

export default function EducatorUserProfile() {
  const {
    control,
    register,
    handleSubmit,
    errors,
    setValue,
    getValues,
    clearErrors,
  }: any = useForm({
    defaultValues: {},
    mode: "onBlur",
  });
  const { navigate } = useLocation();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const userDetails = userInfo.userJson;
  const [imageError, setImageError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [profileImage, updateProfileImage] = useState<string>("");
  const [profileData, updateProfileData] = useState<any>();
  const [showToast, setShowToast] = React.useState(false);
  const [buttonText, setButtonText] = useState<string>("Save");
  const [phoneError, setPhoneError] = useState<boolean>(false);
  const [zipError, setZipError] = useState<boolean>(false);
  const [disableButton, setDisableButton] = useState<boolean>(true);
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [countryCode, setCountryCode] = useState("+91");

  const assignValuesToForm = useCallback(() => {
    updateProfileImage(userDetails.thumbnailAsset);
    Object.keys(getValues())
      .filter((key) => key !== "profileUrl")
      .map((key: string) => {
        if (key === "state") {
          const stateObject = stateList.find(
            (state) => state.value === userDetails[key]
          );
          setValue(key, stateObject);
        } else if (key === "educatorGrade") {
          const gradeArray: any[] = userDetails[key].split(",");
          const filteredGradeArray = getArrayData(gradeArray, gradesList);
          setValue(key, filteredGradeArray);
        } else if (key === "preferedPronoun") {
          if (userDetails[key]) {
            const pronounObject: any = preferedPronounList.find(
              (pronoun) => pronoun.value === userDetails[key]
            );
            setValue(key, pronounObject.value);
          }
        } else {
          setValue(key, userDetails[key]);
        }
        return key;
      });
    // eslint-disable-next-line
  }, [getValues, setValue, userInfo]);

  useEffect(() => {
    assignValuesToForm();
  }, [assignValuesToForm]);

  function onSubmit(data: any) {
    if (imageError || phoneError || zipError) return;
    const comparedObject = objectComparision(userDetails, data);
    const params: any = {};
    Object.assign(params, {
      userId: userDetails.userId,
      userType: userDetails.userType,
      sessionToken: userInfo.sessionToken,
      ...comparedObject,
    });
    if (profileImage && profileImage.length) {
      if (
        profileData &&
        userDetails &&
        userDetails.profileUrl !== profileData.originalAsset
      ) {
        Object.assign(params, {
          profileUrl: profileData.originalAsset,
          mediumThumbnailAsset: profileData.mediumThumbnailAsset,
          smallThumbnailAsset: profileData.smallThumbnailAsset,
          thumbnailAsset: profileData.thumbnailAsset,
        });
      }
    }
    setButtonText("Saving...");
    updateUser(params)
      .then((response: any) => {
        setButtonText("Save");
        if (response._responseStatus) {
          const userData = { ...userInfo, userJson: response.userJson };
          DataService.sendMessage({ key: "userJson", data: userData.userJson });
          localStorage.setItem("userData", JSON.stringify(userData));
          setUserInfo(userData);
          setShowSuccess(true);
          setDisableButton(true)
        } else if (response.msgCode === "SSN_002") {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: response.msg,
          });
          setShowToast(true);
        }
      })
      .catch((err) => {
        setButtonText("Save");
        console.log(err);
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
      });
  }
  function onCancel() {
    assignValuesToForm();
    clearErrors();
    updateProfileData("");
    setImageError(false);
    updateProfileImage(userDetails.thumbnailAsset);
    setDisableButton(true);
  }

  function onChange(data: any) {
    if (data.target.value !== userDetails[data.target.name]) {
      setDisableButton(false);
    }
    if (data.target.name === "phoneNumber") {
      const actual_val = formatPhoneNumber(data.target.value);
      setValue("phoneNumber", actual_val);
      if (actual_val.length === 14) {
        setPhoneError(false);
      }
    }
    if (data.target.name === "zip") {
      setValue("city", "");
      setValue("state", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }

  function onPhoneBlur(evt: any) {
    if (evt.length >= 11) {
      clearErrors("phoneNumber")
      // console.log(evt.length  === 11)
      setPhoneError(false);
    } else {
      setPhoneError(true);
    }
  }

  function onZipBlur(data: any) {
    if (data.target.value.length !== 5) {
      setZipError(true);
      return;
    }
    setZipError(false);
    getAddress(data.target.value)
      .then((res) => {
        if (res && !res.error) {
          setValue("city", capitalize(res.city));
          clearErrors("city");
          const selectedState = stateList.find(
            (state) => state.value === res.state
          );
          setValue("state", selectedState);
          clearErrors("state");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const showDetails =
    (userDetails.educatorLicenseType === "teacherAccount" &&
      userDetails.educatorGrade) ||
    (userDetails.educatorLicenseType === "schoolLicenseCode" &&
      userDetails.schoolName);

  function Portal() {
    navigate('/educator')
  }
  return (
    <Layout>
      <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
        <FormHeader>
          <span className="back-icon" onClick={() => Portal()}>
            <Icon name="backArrow" />
          </span>
          <FormTitle className="justify-center">
            <h3 className="primary-header text-center">My Educator Account</h3>
          </FormTitle>
        </FormHeader>
        <ImageContainer>
          <ProfileUploader
            name="profileUrl"
            background={profileImage}
            onUpdateImage={updateProfileImage}
            onUpdateImageData={updateProfileData}
            setImageError={setImageError}
            imageError={imageError}
          />
        </ImageContainer>
        <FormFlexWrapper className="two-child-layout mb-0">
          <div className="child mb-0">
            <Input
              label="First Name"
              placeholder="First Name"
              name="firstName"
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.firstName && "Please enter First Name"}
            />
          </div>
          <div className="child">
            <Input
              label="Last Name"
              placeholder="Last Name"
              name="lastName"
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.lastName && "Please enter Last Name"}
            />
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper className="two-child-layout mb-0">
        <div className="child mb-0">
                    <CommonLabel className="label-color">Phone Number</CommonLabel>
                    <Controller
                      name="phoneNumber"
                      control={control}
                      disabled
                      rules={{
                        required: true,
                        //   minLength:11,
                        // maxLength:15 ,
                        // pattern:numberPattern
                      }}
                      render={({ onChange, value }) => (
                        <PhoneInput
                          // disable={true}
                          disableDropdown={true}
                          disabled={true}
                          value={getValues().phoneNumber}
                          // defaultMask={cou}
                          //  name="phoneNumber"
                          onChange={(evt) => {
                            setCountryCode(evt);
                            onPhoneBlur(evt)
                            setValue('phoneNumber', evt)
                            // console.log(evt)

                            // showPhoneInputErr(false)
                            // setPhoneError(true)
                          }}
                          // defaultMask={}
                          country={"us"}
                          preferredCountries={["us", "in","uk","nz","au","ca"]}
                          autoFormat={true}
                          placeholder="Phone Number"
                          specialLabel="Phone Number"
                          // onBlur={onPhoneBlur}
                          containerClass="phone-input disabled non-editable"
                        />

                      )}
                    />

                    {
                      errors.phoneNumber && <Error>Please enter Phone Number</Error> ||
                      (!errors.phoneNumber && phoneError && <Error>Please enter valid Phone Number</Error>)
                    }
                  </div>

          {/* <div className="child mb-0">
            <Input
              label="Phone Number"
              type="number"
              placeholder="Phone Number"
              name="phoneNumber"
              maxLength={14}
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              onBlur={onPhoneBlur}
              error={
                (errors.phoneNumber && "Please enter Phone Number") ||
                (!errors.phoneNumber &&
                  phoneError &&
                  "Please enter valid Phone Number")
              }
            />
          </div> */}

          <div className="child ">
            <Input
              label="Zip Code"
              placeholder="Zip Code"
              name="zip"
              type="number"
              maxLength={5}
              onBlur={onZipBlur}
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={
                (errors.zip && "Please enter Zip Code") ||
                (!errors.zip && zipError && "Please enter valid Zip Code")
              }
            />
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper className="two-child-layout mb-0">
          <div className="child mb-0">
            <Input
              label="City"
              placeholder="City"
              name="city"
              register={register({
                required: true,
                validate: (value: any) => {
                  return value.trim().length > 0;
                },
              })}
              error={errors.city && "Please enter City"}
            />
          </div>
          <div className="child">
            <CommonLabel className="label-color">State</CommonLabel>
            <DropdownWrapper>
              <Controller
                as={<Select onFocus={() => setDisableButton(false)} />}
                value="value"
                name="state"
                options={stateList}
                placeholder="State"
                control={control}
                rules={{ required: true }}
                styles={SelectCustomStyles}
                defaultValue={""}
              />
              {errors.state && <Error>Please select State</Error>}
            </DropdownWrapper>
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper className="mb-0">
          <div className="child only-child">
            <Input
              type="email"
              label="Email Address"
              placeholder="Email Address"
              name="email"
              register={register({})}
              disable={true}
            />
          </div>
        </FormFlexWrapper>
        {showDetails && (
          <Fragment>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <Input
                  label={`School Name ${userDetails.educatorLicenseType === "teacherAccount"
                    ? `(Optional)`
                    : ""
                    } 
                         `}
                  placeholder="School Name"
                  name="schoolName"
                  register={register({})}
                  disable={
                    userDetails.educatorLicenseType === "schoolLicenseCode"
                  }
                />
              </div>
            </FormFlexWrapper>
            {userDetails.educatorLicenseType === "schoolLicenseCode" && (
              <FormFlexWrapper className="two-child-layout mb-0">
                <div className="child mb-0">
                  <Input
                    label="School City"
                    placeholder="School City"
                    name="schoolCity"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    disable={true}
                  />
                </div>
                <div className="child only-child">
                  <Input
                    label="School Zip Code"
                    placeholder="School Zip Code"
                    name="schoolZip"
                    type="number"
                    register={register({
                      required: true,
                      validate: (value: any) => {
                        return value.trim().length > 0;
                      },
                    })}
                    disable={true}
                  />
                </div>
              </FormFlexWrapper>
            )}
            {userDetails.educatorLicenseType === "teacherAccount" && (
              <FormFlexWrapper className="mb-0">
                <div className="child only-child">
                  <Input
                    type="number"
                    hideLabel={false}
                    label="No. of Students in Class"
                    placeholder="No. of Students in Class"
                    name="noOfStudents"
                    register={register({
                      required: true,
                    })}
                    maxLength={2}
                    error={
                      errors.noOfStudents &&
                      "Please enter No. of Students in class"
                    }
                  />
                </div>
              </FormFlexWrapper>
            )}
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <CommonLabel className="alt label-color">Grade</CommonLabel>
                <DropdownWrapper>
                  <Controller
                    as={<Select onFocus={() => setDisableButton(false)} />}
                    value="value"
                    name="educatorGrade"
                    options={gradesList}
                    placeholder="Grade"
                    control={control}
                    rules={{ required: true }}
                    styles={SelectCustomStyles}
                    defaultValue={""}
                    isMulti={true}
                    closeMenuOnSelect={false}
                  />
                  {errors.educatorGrade && (
                    <Error>Please select atleast one Grade</Error>
                  )}
                </DropdownWrapper>
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel className="alt label-color">
                  Preferred Pronouns
                </CommonLabel>
                <FlexWrapper>
                  {preferedPronounList.map((each: any) => (
                    <Radio
                      className="radio mr-3"
                      name="preferedPronoun"
                      value={each.value}
                      key={each.value}
                      checked={true}
                      register={register({
                        required: true,
                      })}
                      id={"pronoun_" + each.value}
                      label={each.label}
                    />
                  ))}
                </FlexWrapper>
                {errors.preferedPronoun && (
                  <Error>Please select Preferred Pronoun</Error>
                )}
              </div>
            </FormFlexWrapper>
          </Fragment>
        )}

        <FlexWrapper className="justify-end">
          <Button
            disabled={disableButton}
            variant="text"
            customClass="mr-1 mr-sm-0 mb-sm-1"
            type="button"
            onClick={() => onCancel()}
          >
            Cancel
          </Button>
          <ButtonContainer
            disabled={disableButton || buttonText === "Saving..."}
            style={{ width: "unset" }}
          >
            <Button variant="newsecondary" type="submit">
              {buttonText}
            </Button>
          </ButtonContainer>
        </FlexWrapper>
      </form>
      {showSuccess && (
        <ProfileUpdtaeDialog
          onClose={() => setShowSuccess(false)}
          message="Changes updated successfully"
          addChild={() => ''}
        />
      )}
      <Toast
        message={toastMessage.message}
        showToast={showToast}
        type={toastMessage.type}
        title="Update Educator"
        onClose={() => setShowToast(false)}
      />
    </Layout>
  );
}
